import React from 'react';

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/production').then(d => ({
    default: d.ReactQueryDevtools,
  })),
);

const TanStackRouterDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-router-devtools').then(d => ({
    default: d.TanStackRouterDevtoolsInProd,
  })),
);

export const DevtoolsProvider = () => {
  const [showDevtools, setShowDevtools] = React.useState(
    process.env.NODE_ENV !== 'production',
  );

  React.useEffect(() => {
    // Add type declaration for window.toggleDevtools
    (
      window as unknown as Window & { toggleDevtools: () => void }
    ).toggleDevtools = () => setShowDevtools(old => !old);
  }, []);

  return showDevtools ? (
    <>
      <React.Suspense fallback={null}>
        <ReactQueryDevtoolsProduction initialIsOpen={false} />
      </React.Suspense>
      <React.Suspense fallback={null}>
        <TanStackRouterDevtoolsProduction initialIsOpen={false} />
      </React.Suspense>
    </>
  ) : null;
};
